import React, { useState } from 'react'
import { string, bool } from 'prop-types'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import { Alert } from 'components/qstrap'

import config from 'config'

const { assets_url: assetsUrl } = config

const aptitudeAssetsPath = `${assetsUrl}/assets/img/aptitude`

const Greeting = ({ name, withAlert }) => {
  const [alert, setAlert] = useState(withAlert)
  const dismissAlert = () => {
    setAlert(false)
  }
  return (
    <div className="aptitude-recommendation-greeting">
      <Container>
        <Alert color="danger" isOpen={alert} toggle={dismissAlert}>
          Yuk, selesaikan ini terlebih dahulu untuk melihat hasil Tes Minat Bakat Kamu!
        </Alert>
        <Row>
          <Col lg="6">
            <div className="aptitude-recommendation-greeting__content">
              <Typography component="h2" variant="title" className="text-variant-title-sm">
                Hi {name}!
              </Typography>
              <Typography component="p" variant="body">
                selamat kamu sudah selesai mengerjakan Tes Minat Bakat di Quipper Campus! Sebelum kamu bisa melihat hasil lengkap Tes Minat Bakat kamu, yuk cek kampus rekomendasi di bawah ini, dan pilih 3 kampus yang kamu minati.
              </Typography>
              <br/>
              <Typography component="p" variant="note" className="aptitude-recommendation__note">
                Pihak kampus yang kamu minati bisa menghubungi untuk memberikan info lebih lengkap mulai dari pendaftaran, biaya kuliah hingga beasiswa.
              </Typography>
            </div>
          </Col>
        </Row>
      </Container>

      <style jsx>
        {`
          .aptitude-recommendation-greeting {
            background-color: #fff;
            display: flex;
            height: calc(100vw * 1.3);
  
            background-size: cover;
            background-position: center bottom;
            background-repeat: no-repeat;
            background-image: url('${aptitudeAssetsPath}/aptitude_recommendation_mobile_bg.png');
  
            @media screen and (min-width: 576px) {
              background-image: url('${aptitudeAssetsPath}/aptitude_recommendation_mobile_bg_x2.png');
            }
  
            @media screen and (min-width: 768px) {
              background-image: url('${aptitudeAssetsPath}/aptitude_recommendation_mobile_bg_x3.png');
              height: calc(100vw * 0.8);
            }
  
            @media screen and (min-width: 1024px) {
              align-items: center;
              background-image: url('${aptitudeAssetsPath}/aptitude_recommendation_bg.png');
              height: calc(100vw / 3.6);
            }
  
            @media screen and (min-width: 1440px) {
              background-image: url('${aptitudeAssetsPath}/aptitude_recommendation_bg_x2.png');
            }
  
            &__content {
              padding-top: 40px;
              padding-bottom: 64px;
            }
  
            :global(.Typography) {
              color: #fff;
            }
            :global(.Typography.text-variant-body) {
              @media screen and (max-width: 576px) {
                font-size: 14px !important;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

Greeting.propTypes = {
  name: string,
  withAlert: bool,
}

export default Greeting
